import React from "react"
import {useAccessToken} from "../../../services/auth"
import useAsyncResultIdle from "../../../hooks/useAsyncResultIdle"
import {IndividualProductApplication, patchIndividualProductApplication} from "../../../resources/productApplication"
import ConfirmationModalContent from "../../ReevaluateApplication/ReevaluateConfirmationModal/ConfirmationModalContent"
import {ReevaluatedIndividualProductApplicationData} from "../Forms/ReevaluateIndividualProductApplicationForm/ReevaluateIndividualProductApplicationForm"

export default function ReevaluateIndividualProductApplicationConfirmationModal(props: {
	close: () => void
	onSuccess: () => void
	application: IndividualProductApplication
	reevaluatedData: ReevaluatedIndividualProductApplicationData
}) {
	const {close, onSuccess, application, reevaluatedData} = props
	const accessToken = useAccessToken()
	const [updateRequest, setUpdateRequest] = useAsyncResultIdle(patchIndividualProductApplication)

	const handleSubmit = (reason: string) => {
		const data = {
			address: reevaluatedData.address,
			phone: reevaluatedData.phone,
			email: reevaluatedData.email,
			dba: reevaluatedData.dba,
			website: reevaluatedData.website,
			industry: reevaluatedData.industry,
			occupation: reevaluatedData.occupation,
			annualIncome: reevaluatedData.annualIncome,
			sourceOfIncome: reevaluatedData.sourceOfIncome,
			annualRevenue: reevaluatedData.annualRevenue,
			numberOfEmployees: reevaluatedData.numberOfEmployees,
			businessVertical: reevaluatedData.businessVertical,
		}

		setUpdateRequest(accessToken, application.id, data, reason)
	}

	return (
		<ConfirmationModalContent
			state={updateRequest}
			close={close}
			onSubmit={handleSubmit}
			onSuccess={onSuccess}
			enableReevaluateApplication={true}
		/>
	)
}
